<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
	 export default {
		 
		 provide(){
			 return{
				 reload:this.reload()
			 }
			 
		 },
		data(){
			return{
				isRouterAlive:true
			}
		},
		methods:{
			reload() {
			      this.isRouterAlive = false; //先关闭，
			      this.$nextTick(function () {
			        this.isRouterAlive = true; //再打开
			      });
			    },
		}
	}
</script>
<style lang="scss">
html{min-height:100%;background: #02081a}
body {
  margin: 0;height:auto;overflow-x:hidden;min-height:100vh;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
